import { FeaturePanelData } from 'lib/contentful/types';
import React from 'react';
import classnames from 'utils/classnames';

type FeaturePanelProps = Omit<FeaturePanelData, 'sys' | '__typename'>;

const FeaturePanel: React.FC<FeaturePanelProps> = (props) => {
  const { title, description, theme } = props;

  return (
    <>
      <div
        className={classnames('rounded p-6', {
          'bg-sf-blue-500/[0.06] text-sf-blue-700': theme === 'light blue',
          'bg-sf-blue-700 text-white': theme === 'blue',
        })}
      >
        {title && (
          <>
            <h3 className="mb-6 text-lg font-medium uppercase">{title}</h3>
          </>
        )}
        {description && <div className="text-base md:text-lg">{description}</div>}
      </div>
    </>
  );
};

export default FeaturePanel;
